/**
 * @Author: wuyang
 * @Date: 2024/1/9
 * @Description: ""
 * 任务列表type最初init的地方
 */

import React, {
	FC,
	memo,
	PropsWithChildren,
	useEffect,
	useMemo,
	useState
} from 'react'
import { TaskListService } from '@/helper/services/task-list/TaskListService'
import { useMatches } from 'react-router-dom'
import { EBizPhone, TBizPhone } from '@/types/bizPhone'
import {
	getTaskListServiceByMap,
	TaskListContext
} from '@/common/services/task-list/taskListContext'
import { BizPhotoNav } from '@/business-component/biz-photo-nav/BizPhotoNav'//导航
import { TaskList } from '@/business-component/task-list/TaskList'//配套任务示意
import { Outlet } from 'react-router'
import { FollowWeChat } from '@/component/follow-weChat'
import { ContextNav } from '@/layout/base/taskNavStory'

export const BizPhotoLayout: FC<PropsWithChildren<{}>> = memo((props) => {
	const [taskListService, setTaskListService] = useState<TaskListService | null>(null)
	const [taskType,setTasktype] = useState(0)//存放任务类型状态
	const [taskGreat,setTaskGreat] = useState(false)//存放任务创建状态

	const matches = useMatches()
	// 要根据二级路径是否发生了变化来判断是否商拍类型需要重新生成
	const parentPath = useMemo(() => {
		return matches?.[2]?.pathname
	}, [matches])

	useEffect(() => {
		let type: EBizPhone = EBizPhone.wig
		const bizs: Record<TBizPhone, EBizPhone> = {
			real: EBizPhone.real,  // 真人图
			mannequin: EBizPhone.mannequin,  // 人台图
			goods: EBizPhone.goods, // 商品图
			wig: EBizPhone.wig,  // 假发图
			texture: EBizPhone.texture,  // 纹理图
      		tabularasa:EBizPhone.tabularasa,  // 白板图
			banana: EBizPhone.banana, // 香蕉大模型
			postureFission: EBizPhone.postureFission, // 姿势裂变
			aiModel: EBizPhone.aiModel, // ai模特
			colorChange: EBizPhone.colorChange, // 商品换色
		}
    //设置任务类型
		for (let t in bizs) {
			if (parentPath.includes(t)) {
				//通过和路径比对得出当前任务类型
				type = bizs[t as TBizPhone]
				if(taskGreat === false){
					setTasktype(type)
				}
			}
		}
		const taskListService = getTaskListServiceByMap({
			type
		})
		if (taskListService) {
			taskListService.refresh()
			setTaskListService(taskListService)
		}

		return () => {}
	}, [parentPath])

	const [a,setA]=useState(0);

	// 判断是否是香蕉Pro
	const isBanana = useMemo(() => {
		return parentPath?.includes('banana')
	}, [parentPath])

	// 判断是否是姿势裂变
	const isPostureFission = useMemo(() => {
		return parentPath?.includes('postureFission')
	}, [parentPath])

	// 判断是否是aiModel
	const isAiModel = useMemo(() => {
		return parentPath?.includes('aiModel')
	}, [parentPath])

	// 判断是否是商品换色
	const isColorChange = useMemo(() => {
		return parentPath?.includes('colorChange')
	}, [parentPath])

	const getTaskListComponent = useMemo(() => {
		// 香蕉Pro使用不同的布局，不渲染TaskList
		if (isBanana || isPostureFission || isAiModel || isColorChange) {
			return (
				<TaskListContext.Provider value={{ taskListService}}>
					<ContextNav.Provider value={{taskType,setTasktype,taskGreat,setTaskGreat,setA,a}}>
						<BizPhotoNav />
						<div className={'flex-1 flex flex-col '} style={{width:`calc(100% - 156px)`}}>
							<Outlet></Outlet>
						</div>
					</ContextNav.Provider>
				</TaskListContext.Provider>
			)
		}

		// 其他类型使用原有布局
		return (
			<TaskListContext.Provider value={{ taskListService}}>
				<ContextNav.Provider value={{taskType,setTasktype,taskGreat,setTaskGreat,setA,a}}>
				<BizPhotoNav />
				<div className={' flex-1 flex'}>
					<TaskList />
					<div className={'flex-1 flex flex-col'}>
						<Outlet></Outlet>
					</div>
				</div>
				</ContextNav.Provider>
			</TaskListContext.Provider>
		)
	}, [taskListService, isBanana])

	return (
    // console.log("我的taskListService"+taskListService),
		<div className={'p-[14px] h-full box-border'}>
			<div className={' bg-white rounded-xl flex overflow-hidden h-full'}>
				{taskListService ? getTaskListComponent : <div></div>}
			</div>
			{/* <FollowWeChat showQr /> */}
		</div>

	)
})
